import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const UserRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.user_view === true ||
    permissions.user_edit === true ||
    permissions.user_create === true
  ) {
    return <Outlet />;
  }
  else {
    return <Navigate to={fallbackPath} />;
  }
};

export default UserRouteMiddleware;
